import { Map } from 'immutable';
import actions from './actions';

const initialState = new Map({
  loading: false,
  error: false,
  issuesOpen: [],
  issuesResolved: [],
  issuesResolvedByUser: [],
  issuesFailedData: {},
  issueDetails: {},
  issueImages: [],
  issueThread: {},
  issueDetailsFailedData: {},
  issueResolving: false,
  issueResolvedData: {},
  issueResolvedFailedData: {}
});

function reducer(state = initialState, action) {

  switch (action.type) {

    // DO_LIST_ISSUES
    case actions.DO_LIST_ISSUES:
      return state
        .set('loading', true);

    case actions.DO_LIST_ISSUES_SUCCESS:
      return state
        .set('loading', false)
        .set('issuesOpen', action.payload.open)
        .set('issuesResolved', action.payload.resolved)
        .set('issuesResolvedByUser', action.payload.resolvedByMe)
        .set('issuesFailedData', {});

    case actions.DO_LIST_ISSUES_FAILED:
      return state
        .set('loading', false)
        .set('issuesOpen', [])
        .set('issuesResolved', [])
        .set('issuesResolvedByUser', [])
        .set('issuesFailedData', action.payload);

    // DO_GET_ISSUE_DETAILS
    case actions.DO_GET_ISSUE_DETAILS:
      return state
        .set('loading', true);

    case actions.DO_GET_ISSUE_DETAILS_SUCCESS:
      return state
        .set('loading', false)
        .set('issueDetails', action.payload.issue)
        .set('issueImages', action.payload.issueImages)
        .set('issueThread', action.payload.inbox)
        .set('issueDetailsFailedData', {});

    case actions.DO_GET_ISSUE_THREAD_SUCCESS:
      return state
        .set('issueThread', action.payload.inbox);

    case actions.DO_GET_ISSUE_THREAD_SUCCESS:
      return state
        .set('loading', false)
        .set('issueThread', action.payload.inbox);

    case actions.DO_GET_ISSUE_DETAILS_FAILED:
      return state
        .set('loading', false)
        .set('issueDetails', {})
        .set('issueDetailsFailedData', actions.payload)

    // DO_RESOLVE_ISSUE
    case actions.DO_RESOLVE_ISSUE:
      return state
        .set('issueResolving', true);

    case actions.DO_RESOLVE_ISSUE_SUCCESS:
      return state
        .set('issueResolving', false)
        .set('issueResolvedData', action.payload)
        .set('issueResolvedFailedData', {});

    case actions.DO_RESOLVE_ISSUE_FAILED:
      return state
        .set('issueResolving', false)
        .set('issueResolvedData', {})
        .set('issueResolvedFailedData', action.payload);

    case actions.DO_RESOLVE_ISSUE_RESET:
      return state
        .set('issueResolving', false)
        .set('issueResolvedData', {})
        .set('issueResolvedFailedData', {});

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/issues/reducer.js